import { HttpClient, HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { FormatModel } from 'src/app/models/formats/format.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FormatService {

  constructor(private _httpClient: HttpClient) { }

  createFormat(formatContract: FormatModel): Observable<FormatModel> {
    return this._httpClient.post<FormatModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.CreateFormat}`,
      formatContract);
  }

  deleteFormat(formatId: number): Observable<FormatModel> {
    return this._httpClient.delete<FormatModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.DeleteFormat}/${formatId}`);
  }

  downloadPreviewPdfAsync(formatId: number, documentId: number): Observable<HttpEvent<Blob>> {
    const params = new HttpParams().set('formatId', formatId).set('documentId', documentId);
    const headers = new HttpHeaders({ 'X-Skip-Loader': 'true' });
    return this._httpClient.get(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.DownloadPreviewPdfAsync}`,
      { params, headers, reportProgress: true, observe: 'events', responseType: 'blob' }
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllFormat(): Observable<Array<FormatModel>> {
    return this._httpClient.get<Array<FormatModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetAllFormat}`)
  }

  getAllFormatsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetAllFormatsForSelectAsync}`,);
  }

  getAllFormatsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetAllFormatsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllPaperSizesForSelectAsync(): Observable<Array<CustomListDropdown>> {
    return this._httpClient.get<Array<CustomListDropdown>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetAllPaperSizesForSelectAsync}`,);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstBranchEnterpriseByCompanyId(companyId: number): Observable<any> {
    return this._httpClient.get<FormatModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetFirstBranchEnterpriseByCompanyIdAsync}/${companyId}`)
  }

  getFirstFormatByKeysAsync(companyId: number): Observable<FormatModel> {
    return this._httpClient.get<FormatModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetFirstFormatByKeys}/${companyId}`);
  }

  getFormatByCompanyAndCode(companyId: number, code: number): Observable<FormatModel> {
    return this._httpClient.get<FormatModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetFormatByCompanyAndCode}/${companyId}/${code}`)
  }

  getFormatByCode(code: number): Observable<FormatModel> {
    return this._httpClient.get<FormatModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetFormatByCode}/${code}`)
  }

  getFormatById(formatId: number | null): Observable<FormatModel> {
    return this._httpClient.get<FormatModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetByIdAsync}/${formatId}`)
  }

  getFormatByMainCompany(): Observable<Array<FormatModel>> {
    return this._httpClient.get<Array<FormatModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetFormatByMainCompany}`)
  }

  getLastFormatByKeysAsync(companyId: number): Observable<FormatModel> {
    return this._httpClient.get<FormatModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetLastFormatByKeys}/${companyId}`);
  }

  getNextFormatByKeysAsync(companyId: number, code: number): Observable<FormatModel> {
    return this._httpClient.get<FormatModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetNextFormatByKeys}/${companyId}/${code}`);
  }

  getPreviusFormatByKeysAsync(companyId: number, code: number): Observable<FormatModel> {
    return this._httpClient.get<FormatModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.GetPreviusFormatByKeys}/${companyId}/${code}`);
  }

  updateFormat(formatContract: FormatModel): Observable<FormatModel> {
    return this._httpClient.put<FormatModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.format.UpdateFormat}`,
      formatContract);
  }
}
